export const RESET_SMS_MESSAGES = 'RESET_SMS_MESSAGES'
export const SET_SMS_MESSAGES = 'SET_SMS_MESSAGES'
